import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getUserData } from "../utils/localStorage";
import { errorMessage } from "../utils/alertMessage";
import { getUser } from "../services/userMasterUser";
import { getLeadType, getUserLead } from "../services/leads";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

const DashboardBranchManager = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 3); // subtract 7 days to current date

  const [startDateValue, setStartDateValue] = useState(new Date(initialStartDate));
  const [endDateValue, setEndDateValue] = useState(new Date());

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" }]

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')
  const [typeOfUserId, setTypeOfUserId] = useState('')

  const [leadData, setLeadData] = useState([])

  const [userData, setUserData] = useState([])

  const userDataApi = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    userTypeIdIn: [],
    roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
    statusIn: [],
    branchIdIn: [userProfileData?.branchInfo?.id]

  };


  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],
    userIdIn: [],
    branchIdIn: [userProfileData?.branchInfo?.id],

    recordType: recordTypeValue,  
    startDate: "",
    endDate: "",
    leadTypeIn: []
  };

  
  const fetchData = (data) => {

    getUser(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const userIds = response.data.map((item) => ({
            label: item.userName + " - " + item?.userTypeInfo,
            value: item.id,
          }));
          setUserData(userIds);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

  };

  useEffect(() => {
    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
          fetchUserLeadData({
            ...typeData,
            recordType: "CreatedOn",
            startDate: startDateValue,
            endDate: endDateValue,
            leadTypeIn: response.data
          });
        }
      })
      .catch(() => errorMessage());
  }, [])

  useEffect(() => {
    if (userProfileData?.branchInfo?.id) {
      fetchData(userDataApi)
    }
  }, [userProfileData?.branchInfo?.id])

  const fetchUserLeadData = (data) => {

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);


          setLeadData(rawData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  useEffect(() => {

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    fetchUserLeadData({
      ...typeData,
      recordType: recordTypeValue,
      startDate,
      endDate,
      leadTypeIn: [typeOfLead],
      userIdIn: [typeOfUserId]
    });

  }, [recordTypeValue, typeOfLead, startDateValue, endDateValue, typeOfUserId]);

  const leadStatusMap2 = Object.groupBy(leadData, item => item.lead.status);

  const statusTotals = Object.fromEntries(
    Object.entries(leadStatusMap2).map(([status, items]) => [
      status,
      items.reduce((sum, item) => sum + item.lead.amount, 0) // change "amount" to your field
    ])
  );

  const result = Object.entries(leadStatusMap2).map(([status, items]) => ({
    status,
    amount: items.reduce((sum, item) => sum + item.lead.amount, 0),
    count: items.length
  }));

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Branch Manager Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <div className="row">
                                <div className=" col-md-6">
                                  <span style={{ color: "#1e439b", fontSize: '15px', }}>
                                    Branch Name:
                                  </span>
                                </div>
                                <div className=" col-md-6">
                                  <span style={{ color: "#ff5501", fontSize: '15px', }}>
                                    {userProfileData.branchInfo.name}
                                  </span>
                                </div>
                              </div>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <div className="row">
                                <div className=" col-md-6">
                                  <span style={{ color: "#1e439b", fontSize: '15px', }}>
                                    Branch Mobile:
                                  </span>
                                </div>
                                <div className=" col-md-6">
                                  <span style={{ color: "#ff5501", fontSize: '15px', }}>
                                    {userProfileData.branchInfo.mobile}
                                  </span>
                                </div>
                              </div>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <div className="row">
                                <div className=" col-md-3">
                                  <span style={{ color: "#1e439b", fontSize: '15px', }}>
                                    Address:
                                  </span>
                                </div>
                                <div className=" col-md-9">
                                  <span style={{ color: "#ff5501", fontSize: '15px', }}>
                                    {userProfileData.branchInfo.address}, {userProfileData.branchInfo.city}, {userProfileData.branchInfo.state}
                                  </span>
                                </div>
                              </div>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                    {isFilterVisible && <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      <div className="row">
                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={userData}
                            value={typeOfUserId}
                            placeholder="Select User Id"
                            onChange={(e) => {
                              setTypeOfUserId(e.value);
                            }}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={leadTypeList}
                            value={typeOfLead}
                            placeholder="Select Lead Type"
                            onChange={(e) => {
                              setTypeOfLead(e.value);
                            }}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={recordTypeSelection}
                            value={recordTypeValue}
                            placeholder="Select Record Type"
                            onChange={(e) => {
                              setRecordTypeValue(e.value);
                            }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={startDateValue}
                            onChange={(e) => {
                              const start = e.value;
                              setStartDateValue(start);

                              if (!endDateValue) {
                                setEndDateValue(new Date()); // default today
                              }
                            }}
                            dateFormat="dd/mm/yy"
                            placeholder="Start Date"
                            maxDate={endDateValue ? endDateValue : new Date()}
                            showIcon
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={endDateValue}
                            onChange={(e) => setEndDateValue(e.value)}
                            dateFormat="dd/mm/yy"
                            placeholder="End Date"
                            minDate={startDateValue}
                            showIcon
                            style={{ width: "100%" }} />
                        </div>
                      </div>


                    </div>}
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Lead Box
                              </span>
                              <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                | {leadData.length} Leads
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {result.map((resultItem) => (
                        <div className=" col-md-4">
                          <div className="card">
                            <Card title="" style={{ color: "#ff5501" }}>
                              <h3 className="m-0">
                                <i className={"bi bi-box"} />
                                <span style={{ color: "#1e439b", marginLeft: 10, textTransform: "capitalize" }}>
                                  {resultItem.status} - {resultItem.count}
                                </span>
                                <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                  | Amount - {resultItem?.amount?.toLocaleString("en-IN")}
                                </span>
                              </h3>
                            </Card>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardBranchManager;
